<template>
  <div class="main_view">
    <!--导航栏-->
    <div class="report_head">
      <div class="report_head_item">
        <div class="report_head_left">
          <div class="report_info">
            <a href="/#/" target="_blank">
              <img src="/static/images/bigdata/maoyan_logo.png"/>
            </a>
          </div>
          <div class="line"></div>
          <div class="note">
            <span>小红书AI智能投放分析：<span style="color: #396AF2; font-weight: bolder">【{{keyWord}}】</span></span>
          </div>
        </div>
        <div class="report_head_right">
          <div class="item_right"  @mouseover="logoutOver" @mouseout="logoutOut">
            <img class="img_head" src="/static/images/bigdata/brand_head_icon.png"/>
            <div class="nick_name">{{nickName}}</div>
            <div class="logout" v-show="showLogin" @click="clickLogout">退 出 登 录</div>
          </div>
        </div>
      </div>
    </div>
    <!--切换栏-->
    <div class="report_home">
      <div class="shop">
        <div class="report_list">
          <div class="report_item_head">
            <div class="report_item_value" v-for="(headItem, headItemIndex) in headItems"
                 :key="headItemIndex" :class="{'selected' : headIndex === headItemIndex }" @click="clickHeadItem(headItemIndex)">{{headItem}}</div>
          </div>
        </div>
      </div>
    </div>

    <!--数据概览-->
    <div class="report_item">
      <div class="head_item">
        <span>报备数据概览</span>
      </div>
      <div class="report show_item">
        <div class="show_child_item" v-for="(result, resultIndex) in guideLists">
          <span class="name">{{result.value}}</span>
          <span class="note">{{result.title}}</span>
        </div>
      </div>
    </div>

    <div class="report_echarts_double">
      <!--echarts柱状图 笔记发布数量分布-->
      <div class="report_echarts_one">
        <div class="echarts_head">
          <span>报备发布时间分布图</span>
        </div>
        <div class="echarts_map" ref="bar_chart_publish">
        </div>
      </div>
      <div class="report_echarts_two">
        <div class="echarts_head">
          <span>报备达人粉丝分布图</span>
        </div>
        <div class="echarts_map" ref="bar_chart_kols_fans">
        </div>
      </div>

    </div>
    <!--echarts饼状图 合作类型 笔记类型-->
    <div class="report_trend">
      <div class="report_echarts_one">
        <div class="echarts_head">
          <span>报备合作类型</span>
        </div>
        <div class="echarts_map" ref="pie_chart_coop">
        </div>
      </div>
      <div class="report_echarts_two">
        <div class="echarts_head">
          <span>报备笔记类型</span>
        </div>
        <div class="echarts_map" ref="pie_chart_type"></div>
      </div>
    </div>
    <!--echarts词云图 笔记标题词云 笔记内容词云-->
    <div class="report_trend">
      <div class="report_echarts_one">
        <div class="echarts_head">
          <span>报备标题词云</span>
        </div>
        <div class="echarts_map" ref="word_chart_title">
        </div>
      </div>
      <div class="report_echarts_two">
        <div class="echarts_head">
          <span>报备内容词云</span>
        </div>
        <div class="echarts_map" ref="word_chart_content"></div>
      </div>
    </div>
    <!--报备笔记列表-->
    <div class="waterfall_head">
      <span>报备笔记TOP20</span>
    </div>
    <div class="waterfall" :style="waterfallStyle">
      <vue-waterfall-easy
        ref="waterfall"
        :imgsArr="dataList"
        :srcKey="'img'"
        @click="wf_clickFn"
        :maxCols="4"
        :gap="10"
        :mobileGap="10"
        @scrollReachBottom="wf_onBottomLoad"
        :enablePullDownEvent="true"
        @pullDownMove="wf_pullDownMove"
        @pullDownEnd="wf_pullDownEnd"
      >
        <div class="img-info" slot-scope="props">
          <span class="text-info">{{ props.value.title }}</span>
          <div class="note-append">
            <div class="note-user">
              <div class="user-image-wrapper">
                <img
                  :src="props.value.author_img"
                  class="user-image">
              </div>
              <span class="name">{{ props.value.author_name }}</span>
            </div>
            <div class="like">
              <p class="heart"></p>
              <span class="likes">{{ props.value.liked_count }}</span>
            </div>
          </div>
        </div>
        <div slot="waterfall-over"></div>
      </vue-waterfall-easy>
    </div>
    <!--底部导航-->
<!--    <div  class="bottom_div">COPYRIGHT  2020-2023 杭州袤周云计算有限公司<a rel="nofollow" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022031665号</a></div>-->
  </div>
</template>

<script>
import vueWaterfallEasy from 'vue-waterfall-easy'
import * as echarts from 'echarts';
import 'echarts-wordcloud';
import process from "shelljs";
export default {
  name: "BigdataNote",
  components: {
    vueWaterfallEasy
  },
  data() {
    return {
      showLogin: false,
      nickName: this.$cookies.get('UserName') || '演示账号',
      keyWord: this.$cookies.get('KeyWord'),
      headIndex: 5,
      headItems: ['达人分析', '笔记分析', '达人列表', '笔记列表', '爆文分析', '报备分析'],
      guideLists: [],
      waterfallStyle: {height: '450px'}, //下拉列表-高度
      dataList: [], //下拉列表-数据
      pageIndex: 1, //下拉列表-页码
      pageSize: 20, //下拉列表-每页加载数量
      pullDownDistance: 0 //下拉列表-下拉距离
    }
  },
  methods: {
    clickHeadItem (headIndex) {
      // 跳转
      if (headIndex === 0) {
        this.$router.push('/bigdata')
      }
      if (headIndex === 1) {
        this.$router.push('/note')
      }
      if (headIndex === 2) {
        this.$router.push('/kollist')
      }
      if (headIndex === 3) {
        this.$router.push('/notelist')
      }
      if (headIndex === 4) {
        this.$router.push('/notehot')
      }
    },
    clickLogout () {
      // 本地保存token
      this.$cookies.remove("UserToken");
      this.$cookies.remove("UserName");
      // 跳转
      this.$router.push('/login');
    },
    logoutOver () {
      this.showLogin = true;
    },
    logoutOut () {
      this.showLogin = false;
    },
    getListData() {
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com';
      }
      let url = '/api/v2/maocep/maocep_vue_xhs_echarts_bbs';
      //数据请求 HTTP_AUTHORIZATION
      this.$axios.defaults.headers.common['Authorization'] = this.$cookies.get('UserToken')
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'keyword': this.$cookies.get('KeyWord')
        })
      }).then((res) => {
        console.log("res ", res);
        // ===数据概览===
        let guidedata = res.data.result[0].guide_data;
        let guide_dic1 = { title: '笔记总数', value: guidedata.note_counts};
        let guide_dic2 = { title: '达人总数', value: guidedata.note_kols_counts};
        let guide_dic3 = { title: '预估图文费用', value: guidedata.note_image_prices};
        let guide_dic4 = { title: '预估视频费用', value: guidedata.note_video_prices};
        this.guideLists = [guide_dic1, guide_dic2, guide_dic3, guide_dic4];
        // ===柱状图===
        let bardata = res.data.result[0].bar_data;
        // 笔记发布时间数量
        let baroption_publish = {
          tooltip: {
            show: true,
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: bardata.notes_publish.x_names,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: bardata.notes_publish.y_vales,
              type: 'bar',
              barWidth: 10,
              smooth: true,
              color: '#396AF2'
            }
          ]
        }
        let barchart_publish = echarts.init(this.$refs.bar_chart_publish);
        barchart_publish.setOption(baroption_publish);
        // 笔记达人粉丝数量
        let baroption_kols_fans = {
          tooltip: {
            show: true,
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: bardata.notes_kols_fans.x_names,
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: bardata.notes_kols_fans.y_vales,
              type: 'bar',
              barWidth: 20,
              smooth: true,
              color: '#396AF2'
            }
          ]
        }
        let barchart_kols_fans = echarts.init(this.$refs.bar_chart_kols_fans);
        barchart_kols_fans.setOption(baroption_kols_fans)
        // ===饼状图===
        // 合作类型
        let piedata = res.data.result[0].pie_data;
        let peidata_coop = [];
        for(let i = 0; i　< piedata.note_coop.x_names.length; i++) {
          let ndic = { name: piedata.note_coop.x_names[i], value: piedata.note_coop.y_vales[0][i]};
          peidata_coop.push(ndic);
        }
        let pieoption_coop = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            top: '10%',
            left: 'center'
          },
          color: ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939'],
          series: [
            {
              name: piedata.note_coop.y_names[0],
              type: 'pie',
              top: '20%',
              radius: '50%',
              data: peidata_coop,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        let piechart_coop = echarts.init(this.$refs.pie_chart_coop);
        piechart_coop.setOption(pieoption_coop);
        // 笔记类型
        let peidata_type = [];
        for(let i = 0; i　< piedata.note_type.x_names.length; i++) {
          let ndic = { name: piedata.note_type.x_names[i], value: piedata.note_type.y_vales[0][i]};
          peidata_type.push(ndic);
        }
        let pieoption_type = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            top: '10%',
            left: 'center'
          },
          color: ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939'],
          series: [
            {
              name: piedata.note_type.y_names[0],
              type: 'pie',
              top: '20%',
              radius: '50%',
              data: peidata_type,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        let piechart_type = echarts.init(this.$refs.pie_chart_type);
        piechart_type.setOption(pieoption_type);
        // ===词云图===
        let worddata = res.data.result[0].wordcloud_data;
        // 标题词云
        let wordata_title = [];
        for(let i = 0; i　< worddata.note_title_keywords.x_names.length; i++) {
          let ndic = { name: worddata.note_title_keywords.x_names[i], value: worddata.note_title_keywords.y_vales[0][i]};
          wordata_title.push(ndic);
        }
        let wordoption_title = {
          series: [
            {
              data: wordata_title,
              type: 'wordCloud',
              shape: "smooth",
              textStyle:  {
                color() {
                  let colors = ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939']
                  return colors[parseInt(Math.random() * 5)]
                }
              },
            }
          ]
        }
        let wordchart_title = echarts.init(this.$refs.word_chart_title);
        wordchart_title.setOption(wordoption_title);
        // 内容词云
        let wordata_content = [];
        for(let i = 0; i　< worddata.note_content_keywords.x_names.length; i++) {
          let ndic = { name: worddata.note_content_keywords.x_names[i], value: worddata.note_content_keywords.y_vales[0][i]};
          wordata_content.push(ndic);
        }
        let wordoption_content = {
          series: [
            {
              data: wordata_content,
              type: 'wordCloud',
              shape: "smooth",
              textStyle:  {
                color() {
                  let colors = ['#396AF2', '#F5a20A', '#F52c9b', '#52C1D0', '#F23939']
                  return colors[parseInt(Math.random() * 5)]
                }
              },
            }
          ]
        }
        let wordchart_content = echarts.init(this.$refs.word_chart_content)
        wordchart_content.setOption(wordoption_content)

        // 报备列表
        this.dataList = res.data.result[0].list_data
        // 瀑布流高度动态
        if (this.dataList.length <= 4) {
          this.waterfallStyle = {height: '460px'}
        }
        if (this.dataList.length > 4 && this.dataList.length <= 8) {
          this.waterfallStyle = {height: '910px'}
        }
        if (this.dataList.length > 8 && this.dataList.length <= 16) {
          this.waterfallStyle = {height: '1360px'}
        }
        if (this.dataList.length > 16 && this.dataList.length <= 20) {
          this.waterfallStyle = {height: '1810px'}
        }
        if (this.dataList.length > 20) {
          this.waterfallStyle = {height: '2270px'}
        }
        // 不上拉加载更多了
        this.$refs.waterfall.waterfallOver()
        console.log("dataList ", this.dataList)
        console.log("pageIndex ", this.pageIndex)
      }).catch((res) => {
        console.log("..fail: ", res)
      })
    },
    wf_clickFn(event, {index, value}) {
      console.log("img clicked", index, value);
      let selectdata = this.dataList[index]
      window.open(selectdata.url, '_blank')
      // this.$router.push({path: '/testdetail', query: {article_id: selectdata.id}})
      // // 阻止a标签跳转
      // event.preventDefault();
      // // 只有当点击到图片时才进行操作
      // if (event.target.tagName.toLowerCase() === "img") {
      //   console.log("img clicked", index, value);
      //   // this.$router.push({path: '/testdetail', query: {article_id: selectdata.id}})
      // }
    },
    wf_pullDownMove(pullDownDistance) {
      console.log('pullDownDistance', pullDownDistance);
      // this.pullDownDistance = pullDownDistance;
    },
    wf_pullDownEnd(pullDownDistance) {
      console.log('pullDownEnd');
      // if (this.pullDownDistance > 60) {
      //   this.wf_onRefresh();
      // }
      // this.pullDownDistance = 0;
    },
    wf_onRefresh() {
      //下拉刷新
      console.log("onRefresh ");
      // this.pageIndex = 1;
      // this.getListData();
    },
    wf_onBottomLoad() {
      //上拉加载
      console.log("onBottomLoad ");
      // this.pageIndex = this.pageIndex + 1;
      // this.getListData();
    },
  },
  mounted () {
    console.dir(this.$cookies);
    if (this.$cookies.get('UserToken')) {
      this.getListData();
    } else {
      console.dir('退出登录');
      this.clickLogout ();
    }
  },
  metaInfo: {
    title: "袤-AI数据挖掘系统",
    meta: [
      { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
      { name: "keywords", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "description", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "format-detection", content: "telephone=no,email=no" }
    ],
    link: [{
      rel: 'shortcut icon',
      href: '/static/favicon.ico'
    }]
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../comm/css/base.styl'
.main_view
  height 100vh
  -webkit-overflow-scrolling touch
  background-color $brand-bgm
  display flex
  flex-direction column
  width 100%
  overflow-y scroll
  overflow-x hidden
  position absolute

  .report_head
    position absolute
    left 0
    top 0
    width 100%
    z-index 1
    background-color $white
    height 75px
    box-shadow 0 1px 8px 0 rgba(0,0,0,0.1)
    .report_head_item
      width 1000px
      height 75px
      display flex
      margin 0 auto
      flex-direction row
      align-items center
      justify-content space-between
      .report_head_right
        width auto
        display flex
        position relative
        height 75px
        flex-direction row
        align-items center
        .item_right
          width auto
          display flex
          position relative
          height 75px
          flex-direction row
          align-items center
          .img_head
            height 32px
            border-radius 50px
            width 32px
          .logout
            position absolute
            width 120px
            height 38px
            display flex;
            flex-direction column
            align-items center
            justify-content center
            color $white
            cursor pointer
            z-index 1
            right 0
            top 60px
            font-size 14px
            background $grey
          .nick_name
            color $color-two
            font-size 14px
            margin-left 10px
      .report_head_left
        width auto
        display flex
        flex-direction row
        align-items center
        height auto
        .note
          margin-left 15px
          color $color-two
          font-size 20px
          font-weight bold;
          width auto
          display flex
          position relative
          height 75px
          flex-direction row
          align-items center
        .line
          margin-left 10px
          width 1px
          height 57px
          background-color $colorE
        .report_info
          height auto
          display flex
          flex-direction column
          img
            height auto


  .report_home
    display flex
    flex-direction row
    justify-content center
    margin 0 auto
    margin-top 90px
    width 1000px
    .shop
      display flex
      flex-direction row
      width 100%
      .report_list
        display flex
        width 100%
        flex-direction column
        .report_item_head
          display flex
          margin-top 15px
          margin-bottom 15px
          width 100%
          align-items center
          justify-content center
          flex-direction row
          .report_item_value
            height 30px
            width auto
            line-height 30px
            margin-right 40px
            font-size 12px
            cursor pointer
            color $color-six
            &.selected
              border-bottom solid 3px $brand-blue
              font-weight bold
              color $brand-blue
              font-size 14px

  .report_item
    display flex
    flex-direction column
    margin 0 auto
    width 1000px
    height auto
    .head_item
      margin-top 10px
      height 30px
      display flex
      position relative
      align-items center
      color #111
      font-size 16px
    .report
      width 100%
      border-radius 12px
      height auto
      background-color $white
      display flex
      flex-direction row
      &.show_item
        padding-top 10px
        background-color $brand-bgm
        flex-wrap wrap
      .show_child_item
        display flex
        margin-bottom 5px
        width 240px
        border-radius 12px
        height 150px
        justify-content center
        align-content center
        align-items center
        flex-direction column
        background-color $white
        margin-right 10px
        .name
          color $brand-blue
          font-size 24px
        .note
          margin-top 5px
          font-size 12px
          font-weight inherit
          color $brand-gray

  .report_echarts_double
    display flex
    flex-direction row
    margin 0 auto
    height auto
    .report_echarts_one
      width 490px
      .echarts_head
        margin-top 10px
        margin-bottom 10px
        height 30px
        display flex
        position relative
        align-items center
        color #111
        font-size 16px
      .echarts_map
        border-radius 12px
        width 100%
        height 300px
        background-color $white
    .report_echarts_two
      width 490px
      margin-left 20px
      .echarts_head
        margin-top 10px
        margin-bottom 10px
        height 30px
        display flex
        position relative
        align-items center
        color #111
        font-size 16px
      .echarts_map
        border-radius 12px
        width 100%
        height 300px
        background-color $white

  .report_echarts
    display flex
    flex-direction column
    margin 0 auto
    margin-bottom 20px
    width 1000px
    height auto
    .echarts_head
      margin-top 10px
      margin-bottom 10px
      height 30px
      display flex
      position relative
      align-items center
      color #111
      font-size 16px
    .echarts_map
      border-radius 12px
      width 100%
      height 300px
      background-color $white

  .report_trend
    display flex
    flex-direction row
    margin 0 auto
    height auto
    .report_echarts_one
      width 490px
      .echarts_head
        margin-top 10px
        margin-bottom 10px
        height 30px
        display flex
        position relative
        align-items center
        color #111
        font-size 16px
      .echarts_map
        border-radius 12px
        width 100%
        height 300px
        background-color $white
    .report_echarts_two
      width 490px
      margin-left 20px
      .echarts_head
        margin-top 10px
        margin-bottom 10px
        height 30px
        display flex
        position relative
        align-items center
        color #111
        font-size 16px
      .echarts_map
        border-radius 12px
        width 100%
        height 300px
        background-color $white


  .waterfall_head
    display flex
    flex-direction column
    margin 0 auto
    margin-top 10px
    margin-bottom 20px
    width 1000px
    height 30px

  .waterfall {
    position absolute
    top 1450px
    bottom 0
    width 100%
    height 1350px
  }

/deep/ .vue-waterfall-easy-container {
  .img-inner-box {
    border-radius  5px !important
    background-color  white !important
    box-shadow  none !important
    .img-wraper > img {
      border-radius  5px 5px 0 0 !important
    }
  }

  .img-info {
    display  flex
    flex-direction  column
    justify-content  flex-start
    align-items  flex-start

    .text-info {
      padding  0
      margin  10px 15px
      color  #000
      font-size  16px
      font-weight  400
      line-height  24px
    }

    .note-append {
      padding-left 10px
      width 90%
      display  flex
      flex-direction  row
      justify-content  space-between

      .note-user {
        display  flex
        flex-direction  row
        align-items  center

        .user-image-wrapper {
          width  28px
          height  28px
          border-radius  50%
          position  relative
          overflow  hidden

          .user-image {
            position  absolute
            width  100%
            height  100%
          }
        }

        .name {
          width  87px
          white-space  nowrap
          text-overflow  ellipsis
          overflow  hidden
          margin-left  10px
          color  #555
          font-size  12px
        }
      }

      .like {
        display  flex
        flex-direction  row
        align-items  center

        .heart {
          width 18px
          height 18px
          background-image url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAgCAYAAAB6kdqOAAAAAXNSR0IArs4c6QAAA3JJREFUWAnNlz1ok0EYx/NhsBiwDfWjHRq31LV1bwm0Ch2sXxQhg4JtAq04CKU6ODmYQuvgB5i0Dg4ZLIqCUBClQRd1kAoumkVIA37UEjqkVGISf8+buzYNSZpvPLg8d889z/1/793l3sRk+s+KuRyehYUFazweP2S1WtttNlvc6XT+dLvdf0vlhsPhPdFo9HAymXSkUqk1h8Pxa2RkJFUqR8aKAmUyGfP8/PzZdDrtMZvNg/TtejL6m7SXsI9bW1tDWkjA19fXPcSeZ9yNbcnJSdB/ZbFYQqOjo0/JzeixXFsQCJAenuohgT0SLMmUHzTXqA5qJ9VClfKFlfNJg5wA5qi0KWnqd2qc2s4cHcyh9ZbJuQTYMmM7ig7Ycs7NzZ1jVR7h2EeNMtE0Ez3z+XwyuVECgcAB/CfpTDHmwiazIyYb/gjVzxwvyPmt/CZyOvGfJn4Kn5O6wWpdGBsbe6JjxO4AYmX6eMrX+G3UYFdX15WhoaE/ElioyDmJRCI3Gbumxv0ul+tGqfO1uLi4d2Vl5Q7xXmqSlRpgpd6q/G2gUCjkSCQSX3mCgzzJtNfr1SI6tqgNBoP9MkjOm6JBeQPk+GW10Fq12+3dHo9HtnYbiCW9RV8gwkw8QKCcgYYVYCxAyW64qX6297qIGQcTGNmiccNhsUw2GkZ0RIMzNCltyrhiyAKxj3049xP0iUP20QhpwodoiaZoK4YsEAf5mNJfagJHvoShqRmMLYOyQ6LY11h+dKP7WlMz6MvNuNJxWhsNkD9/jqbBYABBKbewFGfWNPXziFIzLl69Ze/ECdjxpqJkNQeV5nuxBlBbW9sHlm6VfjdfP7kXmlKUVrdo843bBlJv61lFMSPXe6OJlMaM0pkFKi1tfahlu+7i/IavNxaLPVCBDTNKo1c0RVsLbQFxdW8wMEyA/G65yHLe00H1tjK3aCitYdHWGltA4mDgM4FnCNykO9EIKDXnhGiIlmhqGLE7fn7oAV56J2g/J6EFe5+ky3qsFpsLwzyneIm/zJ+vIJAE1RuqHBjRLQpUT6hyYXYFqgdUJTBlAdUCVSlM2UDVQFUDUxFQJVDVwlQMVA5ULTBVAZWCqhWmaqBCUOKjGDcwtuClZ0Ts8lHyHtolN//ylH8S8sqpGkb0agKSCbjR+3nF3DYmM5uvVvJnUXLyyz9Srs7x/T5B0AAAAABJRU5ErkJggg==')
          background-repeat no-repeat
          background-size contain
        }

        .likes {
          max-width 50px
          height 18px
          margin-left 5px
          color #555
          font-size 12px
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/bigdata/BigdataNoteBaobei.vue